module.exports = __webpack_public_path__ + "img/slider-handle.3c8dbb53.svg";